import {ApplicationConfig,importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withRouterConfig} from '@angular/router';
import {routes} from "./com/jwebmp/core/base/angular/modules/services/angular/AngularRoutingModule/AngularRoutingModule";
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {AllCommunityModule} from 'ag-grid-community'
import {ModuleRegistry} from 'ag-grid-community'
import {provideCharts} from 'ng2-charts'
import {withDefaultRegisterables} from 'ng2-charts'
import Prism from 'prismjs'
import 'prismjs/components/prism-markup'
import 'prismjs/components/prism-css'
import 'prismjs/components/prism-clike'
import 'prismjs/components/prism-javascript'
import 'prismjs/components/prism-typescript'
import 'prismjs/components/prism-java'
import 'prismjs/components/prism-json'
import 'prismjs/components/prism-bash'
import 'prismjs/components/prism-yaml'
import 'prismjs/components/prism-xml-doc'
import 'prismjs/components/prism-sql'
import 'prismjs/components/prism-properties'
import 'prismjs/components/prism-diff'
import 'prismjs/components/prism-kotlin'
import 'prismjs/components/prism-groovy'
import 'prismjs/components/prism-python'
import 'prismjs/components/prism-scss'
import 'prismjs/components/prism-markdown'
import 'prismjs/plugins/line-numbers/prism-line-numbers'
import 'prismjs/plugins/toolbar/prism-toolbar'
import mermaid from 'mermaid'
import ClipboardJS from 'clipboard'
import {provideMarkdown} from 'ngx-markdown'
import {MERMAID_OPTIONS} from 'ngx-markdown'
import {CLIPBOARD_OPTIONS} from 'ngx-markdown'
import {provideHttpClient} from '@angular/common/http'
import {LOCALE_ID} from '@angular/core'
import {registerLocaleData} from '@angular/common'
import localeEnZa from '@angular/common/locales/en-ZA'
(globalThis as any).Prism = Prism;
(globalThis as any).mermaid = mermaid;
(globalThis as any).ClipboardJS = ClipboardJS;

export const appConfig: ApplicationConfig = {
providers: [provideZoneChangeDetection({eventCoalescing: true}), provideRouter(routes, withRouterConfig({
urlUpdateStrategy: 'eager',
paramsInheritanceStrategy:'always'
})),provideAnimations(),provideAnimationsAsync(),provideCharts(withDefaultRegisterables()),
provideMarkdown({ mermaidOptions: { provide: MERMAID_OPTIONS, useValue: { startOnLoad: false } }, clipboardOptions: { provide: CLIPBOARD_OPTIONS, useValue: { buttonComponent: undefined } } }),
{ provide: LOCALE_ID, useValue: 'en-ZA' },
provideHttpClient(),
]
};
